import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { GenreUploadFormStyled } from './styled';
// import { iconImages } from 'assets'
import { VALIDATE } from 'helpers';
import { ButtonCustom, InputUploadFIle, Card } from 'components';

class GenreUploadForm extends React.Component {
  state = {};

  uploadFile = (file) => {
    this.setState({
      uploadFile: true,
    })
  }

  render() {
    const { handdleSave, handleSubmit, initialValues } = this.props;
    const { uploadFile } = this.state;
    return (
      <GenreUploadFormStyled>
        <form onSubmit={handleSubmit(handdleSave)}>
          <Card title="Genre Poster">
            <div className="item_layout">
              <Field
                theme_standard
                name="photo_file"
                accept="image/x-png,image/gif,image/jpeg"
                buttonLabel="Picture"
                component={InputUploadFIle}
                validate={VALIDATE.REQUIRE}
                title="Photo"
                width={250} height={150}
                haveFilePhoto={initialValues && initialValues.photo_file ? true : false}
                onChange={this.uploadFile}
              />
            </div>
            <div className="item_layout">
              <Field
                theme_standard
                name="video_file"
                accept="video/mp4,video/x-m4v,video/*"
                buttonLabel="Upload Video"
                width="350" height="240"
                component={InputUploadFIle}
                title="Video"
                haveFileVideo={initialValues && initialValues.video_file ? true : false}
                onChange={this.uploadFile}
              />
            </div>
            <div className="button_layer">
              <ButtonCustom
                theme_haveFile
                label={this.props.loading ? "LOADING" : "SAVE"}
                uploadFile={uploadFile}
                disabled={uploadFile ? this.state.loading ? true : false : true}
              />
            </div>
          </Card>
        </form>
      </GenreUploadFormStyled>
    );
  }
}

export default reduxForm({
  form: 'GenreUploadForm', // a unique identifier for this form
  enableReinitialize: true,
})(GenreUploadForm);
